<header class="report-header">
  <div class="container report-header__inner">
    <!-- Rangée 1 — identité et actions -->
    <div class="report-header__row">
      <div class="report-header__identity">
        <span class="brand-logo brand-logo--header"><img class="brand-logo__img brand-logo__img--ink" src="assets/images/report/logo-skill2era-dark.png" alt="Skill2era" width="447" height="178"><img class="brand-logo__img brand-logo__img--paper" src="assets/images/report/logo-skill2era.png" alt="" aria-hidden="true" width="447" height="178"></span>
        <span class="report-header__divider" aria-hidden="true"></span>
        <span class="avatar">
          <span class="avatar__fallback">{{ view().header.initials }}</span>
        </span>
        <div class="report-header__names">
          <div class="report-header__name-row">
            <h1 class="report-header__name">{{ view().header.studentName }}</h1>
            @if (view().header.sessionCount > 0) {
              <span class="badge badge--primary badge--sm">{{ 'header.sessionLabel' | reportT: sessionVars() }}</span>
            }
          </div>
          <!-- Le parcours tient lieu de classe : une seule mention, donc pas de
               séparateur — la maquette en alignait deux, valeurs de démonstration. -->
          @if (view().header.learningPathTitle; as path) {
            <p class="report-header__sub"><span>{{ path }}</span></p>
          }
        </div>
      </div>

      <!-- Ni bascule de thème ni sélecteur de langue : l'application possède
           déjà les deux, et le rapport les suit. Ni bouton « télécharger le
           PDF » : le PDF est cette page imprimée, pas un second document. -->
      <div class="report-header__actions no-print">
        <button type="button" class="btn btn--outline btn--md" (click)="backRequested.emit()">
          <i [class]="backIcon()" aria-hidden="true"></i>
          <span class="btn__label">{{ 'BUTTONS.BACK' | translate }}</span>
        </button>

        <button type="button" class="btn btn--outline btn--md" data-action="print"
                [disabled]="print.preparing()" (click)="startPrint()">
          <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"/><rect x="6" y="14" width="12" height="8" rx="1"/></svg>
          <span class="btn__label">{{ 'header.print' | reportT }}</span>
        </button>
      </div>
    </div>

    <!-- Rangée 2 — métadonnées du test -->
    <dl class="report-header__meta">
      <div class="meta-item">
        <span class="meta-item__icon"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 5v16"/><path d="M20.001 19A2 2 0 0022 17V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2z"/></svg></span>
        <div class="meta-item__text">
          <dt class="meta-item__label">{{ 'header.subject' | reportT }}</dt>
          <!-- Déjà résolu par le modèle : nom de matière de l'API, ou mention
               « toutes les matières ». -->
          <dd class="meta-item__value"><span>{{ view().header.subjectLabel }}</span></dd>
        </div>
      </div>
      @if (view().header.testTitle; as test) {
        <div class="meta-item">
          <span class="meta-item__icon"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/></svg></span>
          <div class="meta-item__text">
            <dt class="meta-item__label">{{ 'header.test' | reportT }}</dt>
            <dd class="meta-item__value"><span>{{ test }}</span></dd>
          </div>
        </div>
      }
      @if (view().header.completedAt; as completedAt) {
        <div class="meta-item">
          <span class="meta-item__icon"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M8 2v3"/><path d="M16 2v3"/><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M8 13h.01"/><path d="M12 13h.01"/><path d="M16 13h.01"/><path d="M8 17h.01"/><path d="M12 17h.01"/><path d="M16 17h.01"/></svg></span>
          <div class="meta-item__text">
            <dt class="meta-item__label">{{ 'header.date' | reportT }}</dt>
            <dd class="meta-item__value"><span>{{ completedAt | reportFmt: 'date' }}</span></dd>
          </div>
        </div>
      }
      @if (duration(); as d) {
        <div class="meta-item">
          <span class="meta-item__icon"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></span>
          <div class="meta-item__text">
            <dt class="meta-item__label">{{ (view().header.durationIsTotal ? 'header.totalDuration' : 'header.duration') | reportT }}</dt>
            <dd class="meta-item__value"><span>{{ d.key | reportT: d.vars }}</span></dd>
          </div>
        </div>
      }
    </dl>

    <!-- Rangée 3 — barre de matières. Absente de la maquette : le document
         d'origine ne décrivait qu'une matière. Jamais imprimée, c'est une
         commande d'écran. -->
    @if (showSubjectNav()) {
      <nav class="report-subjectnav no-print" [attr.aria-label]="'DIAGNOSTIC_REPORT.FILTER_SUBJECT' | translate">
        @for (entry of subjectNav(); track entry.id) {
          <button type="button" class="report-subjectnav__item"
                  [class.is-active]="activeSubjectId() === entry.id"
                  [attr.aria-current]="activeSubjectId() === entry.id ? 'true' : null"
                  (click)="subjectSelected.emit(entry.id)">
            <span>{{ entry.label }}</span>
            @if (entry.percentage !== null) {
              <span class="report-subjectnav__badge">{{ entry.percentage | reportFmt: 'pct' }}</span>
            }
            <span [class]="entry.dotClass" aria-hidden="true"></span>
          </button>
        }
      </nav>
    }
  </div>
</header>
